module.exports = __webpack_public_path__ + "img/icon_3.e5c7037c.png";